import { mergeAttributes, Node } from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    highlightBlock: {
      insertBlock: () => ReturnType
    }
  }
}

export const HighlightBlock = Node.create({
  name: 'highlightBlock',

  group: 'block',

  content: 'block+',

  defining: true,

  isolating: true,

  addCommands() {
    return {
      insertBlock:
        () =>
        ({ commands }) => 
          commands.insertContent(
            `<div data-type="highlight-block"><p></p></div>`,
          )
    }
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'highlight-block', class: `highlight-block` }), 0]
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="highlight-block"]',
      },
    ]
  },
})

export default HighlightBlock
